import { format, formatDistanceToNow, isValid, parseISO } from 'date-fns';
import { enUS, es } from 'date-fns/locale';

// ----------------------------------------------------------------------

function parseDateValue(value) {
  if (!value) return null;

  if (value instanceof Date) {
    return isValid(value) ? value : null;
  }

  if (typeof value === 'number') {
    const parsedNumberDate = new Date(value);
    return isValid(parsedNumberDate) ? parsedNumberDate : null;
  }

  if (typeof value === 'string') {
    const normalizedValue = value.trim();
    if (!normalizedValue) return null;

    const parsedIsoDate = parseISO(normalizedValue.replace(' ', 'T'));
    if (isValid(parsedIsoDate)) return parsedIsoDate;

    const dateOnlyMatch = normalizedValue.match(/^(\d{4}-\d{2}-\d{2})/);
    if (dateOnlyMatch) {
      const parsedDateOnly = parseISO(dateOnlyMatch[1]);
      if (isValid(parsedDateOnly)) return parsedDateOnly;
    }

    const parsedFallbackDate = new Date(normalizedValue);
    return isValid(parsedFallbackDate) ? parsedFallbackDate : null;
  }

  return null;
}

function getDateLocale(language = 'en') {
  return language?.toLowerCase().startsWith('es') ? es : enUS;
}

export function fDate(date) {
  const parsedDate = parseDateValue(date);
  return parsedDate ? format(parsedDate, 'dd MMMM yyyy') : '';
}

export function fDateOnly(date, language = 'en') {
  const parsedDate = parseDateValue(date);

  if (!parsedDate) return date || '';

  const isSpanish = language?.toLowerCase().startsWith('es');

  return format(parsedDate, isSpanish ? "d 'de' MMMM 'de' yyyy" : 'd MMMM yyyy', {
    locale: getDateLocale(language),
  });
}

export function fDateTime(date) {
  const parsedDate = parseDateValue(date);
  return parsedDate ? format(parsedDate, 'dd MMM yyyy HH:mm') : '';
}

export function fDateTimeSuffix(date) {
  const parsedDate = parseDateValue(date);
  return parsedDate ? format(parsedDate, 'dd/MM/yyyy hh:mm p') : '';
}

export function fToNow(date) {
  const parsedDate = parseDateValue(date);
  if (!parsedDate) return '';

  return formatDistanceToNow(parsedDate, {
    addSuffix: true,
  });
}
